<template>
<div class="row">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'project-router',

  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Project/Index.vue